import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance30 = () => {
  let winnerList = [
    "297", "428", "312", "298", "484", "328", "417", "324"
  ];
  return <IndividualTable matchType={"16"} gender="M" event="30" subTitle="Zamby" data={sampleData} topRankCount="8" winners={winnerList} />;
};
export default Distance30;
